/*
 * @Github: https://github.com/wangjiawei2019
 * @Date: 2019-12-12 15:48:31
 * @LastEditors: wjw
 * @LastEditTime: 2019-12-17 16:20:35
 */
export default {
  namespaced: true,
  state: {
    menuList: []
  },
  mutations: {
    setMenuList(state, menuList) {
      state.menuList.push(...menuList);
    }
  },
  getters: {
    getSubTitle: state => (pathOne, pathTwo) => {
      const noSubTitleList = [
        "lesson",
        "teacher",
        "school",
        "student",
        "detail"
      ];
      if (noSubTitleList.includes(pathOne)) return "";
      if (pathOne === "info") {
        const list = ["首页轮播", "组织机构", "头条"];
        return list[pathTwo - 1];
      } else {
        const title = state.menuList.filter(v => v.key == pathOne);
        const subTitle = title[0].subNav.filter(i => i.id == pathTwo);
        return subTitle.length ? subTitle[0].name : "";
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/home.js